export const actionTypes = {
  GET_GEOTREES: "GET_GEOTREES",
  SET_GEOTREES: "SET_GEOTREES",
  GET_GEOTREE_FILTERED_RESULTS: "GET_GEOTREE_FILTERED_RESULTS",
  SET_GEOTREE_FILTERED_RESULTS: "SET_GEOTREE_FILTERED_RESULTS",
  GET_GEOTREE_BY_ID: "GET_GEOTREE_BY_ID",
  SET_GEOTREE_BY_ID: "SET_GEOTREE_BY_ID",
  ADD_GEO_TREE: "ADD_GEO_TREE",
  UPDATE_GEOTREE: "UPDATE_GEOTREE",
  GET_JOB_FUNCTION: "GET_JOB_FUNCTION",
  SET_JOB_FUNCTION: "SET_JOB_FUNCTION",
  GET_POSITIONS: "GET_POSITIONS",
  SET_POSITION_DESC: "SET_POSITION_DESC",
  GET_EMPLOYEES: "GET_EMPLOYEES",
  SET_EMPLOYEES: "SET_EMPLOYEES",
  SET_EDIT_FORM_CHANGE: "SET_EDIT_FORM_CHANGE",
  GET_JOB_FUNCTION_FILTER_DATA: "GET_JOB_FUNCTION_FILTER_DATA",
  SET_JOB_FUNCTION_FILTER_DATA: "SET_JOB_FUNCTION_FILTER_DATA",
};

export const actions = {
  getGeotrees: (payload) => ({
    type: actionTypes.GET_GEOTREES,
    payload: payload,
  }),

  setGeotrees: (payload) => ({
    type: actionTypes.SET_GEOTREES,
    payload: payload,
  }),

  getGeoTreeFilteredResults: (payload) => ({
    type: actionTypes.GET_GEOTREE_FILTERED_RESULTS,
    payload: payload,
  }),

  setGeoTreeFilteredResults: (payload) => ({
    type: actionTypes.SET_GEOTREE_FILTERED_RESULTS,
    payload: payload,
  }),

  getGeoTreeById: (payload) => ({
    type: actionTypes.GET_GEOTREE_BY_ID,
    payload: payload,
  }),

  setGeoTreeById: (payload) => ({
    type: actionTypes.SET_GEOTREE_BY_ID,
    payload: payload,
  }),

  setEditForm: (payload) => ({
    type: actionTypes.SET_EDIT_FORM_CHANGE,
    payload: payload,
  }),

  updateGeoTree: (payload) => ({
    type: actionTypes.UPDATE_GEOTREE,
    payload: payload,
  }),

  getJobFunction: (payload) => ({
    type: actionTypes.GET_JOB_FUNCTION,
    payload: payload,
  }),

  setJobFunction: (payload) => ({
    type: actionTypes.SET_JOB_FUNCTION,
    payload: payload,
  }),

  addGeoTree: (payload) => ({
    type: actionTypes.ADD_GEO_TREE,
    payload: payload,
  }),
  getEmployees: (payload) => ({
    type: actionTypes.GET_EMPLOYEES,
    payload: payload,
  }),
  setEmployees: (payload) => ({
    type: actionTypes.SET_EMPLOYEES,
    payload: payload,
  }),
  getPositions: (payload) => ({
    type: actionTypes.GET_POSITIONS,
    payload: payload,
  }),
  setPositions: (payload) => ({
    type: actionTypes.SET_POSITION_DESC,
    payload: payload,
  }),

  getJobFunctionFilterData: (payload) => ({
    type: actionTypes.GET_JOB_FUNCTION_FILTER_DATA,
    payload: payload,
  }),

  setJobFunctionFilterData: (payload) => ({
    type: actionTypes.SET_JOB_FUNCTION_FILTER_DATA,
    payload: payload,
  }),
};
